// extracted by mini-css-extract-plugin
export default {"loginOrCreateAccountSesssionSaleModalContainer":"src-modules-session-sales-landing-page-non-fsp-style__loginOrCreateAccountSesssionSaleModalContainer_Sovfg"};